import { render, staticRenderFns } from "./em_price.vue?vue&type=template&id=f18a98ca"
import script from "./em_price.vue?vue&type=script&lang=js"
export * from "./em_price.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports